import React, { useEffect, useRef, useState } from "react";
import "./CreateResults.scss";
import { Button, Form, Modal } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencil, faPlus } from "@fortawesome/free-solid-svg-icons";

import { Blocks } from "react-loader-spinner";
import { AppRegistration } from "@mui/icons-material";

import {
  PPE_getApiSync,
  URL_API_PPE,
  getValueFromLocalStorageFunc,
  joinWithCommaNSuffixAnd,
  notify,
} from "../../../services/functions";
import { ToastContainer } from "react-toastify";

import Select from "react-select";

const ModalCreateResults = (props) => {
  const {
    par_show,
    title,
    status,
    row,
    tipeMenu,
    par_statusLoader,
    listFeatures,
    listCameras,
    outChange,
  } = props;

  // title -> 'Create Cameras'
  // status -> Create / Edit
  // row -> row.<key>  -> data per row
  // tipeMenu -> 'Update User Me', default ... (eg : list - users) // indikator ganti is_active dan is_superuser jadi icon
  // par_statusLoader -> show loaders Blocks
  // listFeatures -> data master feature (select)
  // listCameras -> data master camera (select)

  const [show, setShow] = useState(false);
  const [loaderStatus, setLoaderStatus] = useState(true);

  let objMasterInput = {
    Camera: null,
    Feature: null,
    "Raw Data": "",
  };
  const [objValueInput, setObjValueInput] = useState({ ...objMasterInput });

  const objRequired = ["Camera", "Feature", "Raw Data"];

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const refPasswordInput = useRef<HTMLInputElement | null>(null);
  const refFullNameInput = useRef<HTMLInputElement | null>(null);
  const refEmailInput = useRef<HTMLInputElement | null>(null);

  const [optionsFeature, setOptionsFeature] = useState<any>([]);
  const [optionsCamera, setOptionsCamera] = useState<any>([]);
  const [valueFeatureSelect, setValueFeatureSelect] = useState<{} | null>({});
  const [valueCameraSelect, setValueCameraSelect] = useState<{} | null>({});

  // tujuan tanpa dependensi ([]) agar selalu masuk ke useEffect ini untuk focus
  // hanya jalan sekali saat render
  useEffect(() => {}, []);

  useEffect(() => {
    setOptionsFeature([...listFeatures]);
    setOptionsCamera([...listCameras]);
  }, [listFeatures, listCameras]);

  useEffect(() => {
    // set status loader dari luar modal (eg. lagi fetch api)
    setLoaderStatus(par_statusLoader);
  }, [par_statusLoader]);

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const getDataFeature = () => {
    PPE_getApiSync(
      `${URL_API_PPE}/v1/features/?skip=0&limit=1000`,
      null,
      "application/json",
      "GET",
      getValueFromLocalStorageFunc("IOT_TOKEN") ?? "",
    ).then((response) => {
      let statusCodeError = response?.["statusCode"]; // error dari internal
      let responseDetail = response?.["detail"]; // error dari api

      // setTimeout(()=>{

      if (typeof statusCodeError != "undefined") {
        notify("error", response?.["msg"] ?? "", "TOP_CENTER");
        // setOptionsFeature([
        //   {value:0, label:'Feature Label 1'},
        //   {value:1, label:'Feature Label 2'}
        // ])
        return;
      } else if (typeof responseDetail != "undefined") {
        notify(
          "error",
          response?.["detail"]?.[0]?.["msg"] ?? response?.["detail"] ?? "",
          "TOP_CENTER",
        );
        return;
      } else {
        if (Array.isArray(response)) {
          let dataTemp = response.map((objres) => {
            return {
              value: objres?.["id"],
              label: objres?.["feature_name"],
            };
          });

          setOptionsFeature([...dataTemp]);
        }
      }
      // },500)
    });
  };

  useEffect(() => {
    setShow(par_show ?? false);

    setTimeout(() => {
      // if (par_show){
      //   const fetchData = async() => {
      //     // read data features to list
      //     await getDataFeature();
      //   }
      //   fetchData();
      // }
    }, 100);
  }, [par_show]);

  useEffect(() => {
    if (status === "Edit") {
      if (Array.isArray(optionsFeature)) {
        let findItem = optionsFeature.find(
          (x) => x?.["value"] === row?.["id_feature"],
        );
        if (findItem) {
          // set value ke <Select
          setValueFeatureSelect({ ...findItem });
        }
      }

      if (Array.isArray(optionsCamera)) {
        let findItem = optionsCamera.find(
          (x) => x?.["value"] === row?.["id_camera"],
        );
        if (findItem) {
          // set value ke <Select
          setValueCameraSelect({ ...findItem });
        }
      }

      // setValueFeatureSelect

      setObjValueInput((obj) => {
        return {
          Camera: row?.["id_camera"] ?? null,
          Feature: row?.["id_feature"] ?? null,
          "Raw Data": row?.["raw_data"] ?? "",
        };
      });
    } else {
      // reset kosong semua data untuk 'create'

      setObjValueInput({ ...objMasterInput });
      setValueFeatureSelect(null);
      setValueCameraSelect(null);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [row]);

  useEffect(() => {
    // use effect ini ter-call pada saat pertama kali buka modal sampai close modal

    setTimeout(() => {
      if (refEmailInput.current) {
        refEmailInput.current.focus();
        refEmailInput.current.select();
      }
    }, 100);
  }, [status, title, tipeMenu]);

  const onChangeSelectFilterModal = (e, action, menu: "feature" | "camera") => {
    if (action !== "clear") {
      switch (menu) {
        case "feature":
          setValueFeatureSelect({ value: e.value, label: e.label });
          break;
        case "camera":
          setValueCameraSelect({ value: e.value, label: e.label });
          break;
      }

      // set ke value untuk submit
      setObjValueInput((obj: any) => {
        return {
          ...obj,
          [menu === "feature" ? "Feature" : "Camera"]: e.value,
        };
      });
    } else {
      switch (menu) {
        case "feature":
          setValueFeatureSelect(null);
          break;
        case "camera":
          setValueCameraSelect(null);
          break;
      }

      setObjValueInput((obj: any) => {
        return {
          ...obj,
          [menu === "feature" ? "Feature" : "Camera"]: null,
        };
      });
    }
    // setValueFeatureSelect()
  };

  const handleHide = () => {
    // event ketika klik di luar modal
  };

  // kondisi close modal
  const handleClick_ChangePWD = (show: boolean, tipe: "create") => {
    if (tipe === "create") {
      // setShow(show);
      setObjValueInput({ ...objMasterInput });

      // setTimeout(()=>{
      outChange({ tipe: "close_modal", value: show, form: "create" });
      // },100)
    }
  };

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const handleChangeSwitchChecked = (valCheck, nameInput) => {
    if (typeof valCheck != "undefined" && valCheck != null) {
      setObjValueInput((obj) => {
        return {
          ...obj,
          [nameInput]: valCheck,
        };
      });
    }
  };

  const handleChangeInput = (event, tipeInput) => {
    setObjValueInput((obj) => {
      return {
        ...obj,
        [tipeInput]: event.target.value,
      };
    });
  };

  const handleSubmit = () => {
    console.log(objValueInput);

    let keyInvalid: any[] = [];

    // periksa apakah ada data yang kosong
    let tempObjValueInput: any[] = [...objRequired];
    tempObjValueInput.forEach((key) => {
      if (
        objValueInput?.[key] == null ||
        (typeof objValueInput?.[key] == "string" && objValueInput?.[key] === "")
      ) {
        keyInvalid = [...keyInvalid, key];
      }
    });

    // periksa data kosong
    if (keyInvalid.length > 0) {
      notify(
        "error",
        "Input " + joinWithCommaNSuffixAnd(keyInvalid) + " harus dilengkapi !",
        "TOP_CENTER",
      );
      return;
    }

    // periksa validitas email
    if (
      objValueInput?.["Email"] != null &&
      typeof objValueInput?.["Email"] != "undefined"
    ) {
      let pattEmail = new RegExp(
        /[a-zA-Z0-9.,?!$^&-_+=*()[\]]+@[a-zA-Z0-9]+\.[a-zA-Z0-9]{2,}/gi,
      );

      // let exeEmail = pattEmail.exec(objValueInput?.['Email']);
      // console.log(objValueInput?.['Email']);
      // console.log("exeEmail");
      // console.log(exeEmail?.[0]);
      // console.log(exeEmail?.['input']);

      let tesEmail = pattEmail.test(objValueInput?.["Email"]);

      if (!tesEmail) {
        notify("error", "Email tidak valid !", "TOP_CENTER");
        return;
      }
    }

    // periksa password & konfirmasi password
    if (objValueInput?.["Password"] !== objValueInput?.["Konfirmasi Password"]) {
      notify(
        "error",
        "Password dan Konfirmasi Password tidak sama !",
        "TOP_CENTER",
      );
      return;
    }

    let objSubmitToAPI = {};
    let endpoint = "";
    let methodhit = "";

    // menu dropdown bukan "Update User Me"
    // if (!tipeMenu && tipeMenu != 'Update User Me')
    // {
    if (status === "Create") {
      methodhit = "POST";
      endpoint = `${URL_API_PPE}/v1/results`;

      objSubmitToAPI = {
        ...objSubmitToAPI,
        created_at: Math.floor(new Date().getTime() / 1000),
        created_by: parseInt(getValueFromLocalStorageFunc("IOT_USER_ID")),
        updated_at: Math.floor(new Date().getTime() / 1000),
        updated_by: parseInt(getValueFromLocalStorageFunc("IOT_USER_ID")),
      };
    } else if (status === "Edit") {
      methodhit = "PUT";
      endpoint = `${URL_API_PPE}/v1/results/${row?.["id"]}`;

      objSubmitToAPI = {
        ...objSubmitToAPI,
        updated_at: Math.floor(new Date().getTime() / 1000),
        updated_by: parseInt(getValueFromLocalStorageFunc("IOT_USER_ID")),
      };
    }

    // object create / edit dengan kondisi sama
    objSubmitToAPI = {
      ...objSubmitToAPI,
      id_camera: objValueInput?.["Camera"],
      id_feature: objValueInput?.["Feature"],
      raw_data: objValueInput?.["Raw Data"],
    };
    // }

    PPE_getApiSync(
      endpoint,
      objSubmitToAPI ?? null,
      "application/json",
      methodhit,
      getValueFromLocalStorageFunc("IOT_TOKEN") ?? "",
    ).then((response) => {
      setLoaderStatus(true);

      let statusCodeError = response?.["statusCode"]; // error dari internal
      if (typeof statusCodeError != "undefined") {
        notify("error", response?.["msg"], "TOP_CENTER");

        setTimeout(() => {
          setLoaderStatus(false);
        }, 200);

        return;
      }

      if (typeof response?.["detail"] != "undefined") {
        notify(
          "error",
          response?.["detail"]?.[0]?.["msg"] ?? response?.["detail"] ?? "",
          "TOP_CENTER",
        );

        setTimeout(() => {
          setLoaderStatus(false);

          // not authenticated
          // if (response?.['detail'].toString().toLowerCase() == 'not authenticated')
          // {
          //   // jika tidak ada token, maka keluar dari form saja
          //   // setShowModal(false);
          // }
        }, 200);

        return;
      } else {
        // jika success
        notify("success", "Your data was saved!", "TOP_CENTER");

        setTimeout(() => {
          setLoaderStatus(false);
          setShow(false);
          outChange({
            tipe: "close_after_success_save",
            value: false,
            form: "create",
          });
        }, 1500);
      }

      // alert(JSON.stringify(response))
    });
  };

  return (
    <>
      {/* MODAL CREATE USER */}
      <Modal
        show={show}
        // show={this.state.modal.changePWD.show}
        centered={true}
        size="sm"
        backdrop={true}
        onHide={handleHide}
      >
        <Modal.Header
          className={`modalheader modal-header-global ${status === "Edit" ? "edit" : "create"}`}
        >
          <Modal.Title className="dashboard-modal-title">
            {status === "Create" && (
              <>
                <AppRegistration
                  style={{
                    position: "absolute",
                    right: 15,
                    top: 25,
                    zIndex: 0,
                    transform: `scale(1.5)`,
                  }}
                  className="login-dropdown-icon"
                />

                {/* <FontAwesomeIcon icon = {faCamera} className='login-dropdown-icon' color={'darkgreen'} 
                                style = {{position:'absolute', right:15, top:25, zIndex:0, transform:`scale(2)`}}/> */}
                <FontAwesomeIcon
                  icon={faPlus}
                  className="login-dropdown-icon"
                  color={"darkgreen"}
                  style={{
                    position: "absolute",
                    right: 0,
                    top: 10,
                    zIndex: 0,
                    transform: `scale(1.5)`,
                  }}
                />
              </>
            )}

            {status === "Edit" && (
              <>
                <AppRegistration
                  style={{
                    position: "absolute",
                    right: 20,
                    top: 25,
                    zIndex: 0,
                    transform: `scale(1.5)`,
                  }}
                  className="login-dropdown-icon"
                />
                {/* <FontAwesomeIcon icon = {faCamera} className='login-dropdown-icon' color={'darkgreen'} 
                                    style = {{position:'absolute', right:15, top:25, zIndex:0, transform:`scale(2)`}}/> */}
                <FontAwesomeIcon
                  icon={faPencil}
                  className="login-dropdown-icon"
                  color={"darkgreen"}
                  style={{
                    position: "absolute",
                    right: -2,
                    top: 15,
                    zIndex: 0,
                    transform: `scale(1.5)`,
                  }}
                />
              </>
            )}

            {/* <img src = {PassPNG} width = {80} height = {80}
                        style = {{position:'absolute', zIndex:0, top:-30, right:0}}/> */}

            <span className="login-icon-modal-title">
              {title}
              {/* Create User */}
            </span>

            {/* TES DOWNLOAD FILE */}
            {/* <a href = "http://192.168.1.120:3007/download" download> Download </a> */}
          </Modal.Title>
          {/* <span className='dashboard-modal-close'
                  onClick={()=>this.handleClick_ChangePWD(false,'changePWD')}>X</span> */}
        </Modal.Header>

        <Modal.Body>
          <div className="d-flex justify-content-center align-items-center">
            <Blocks
              height="100"
              width="100"
              wrapperStyle={{}}
              wrapperClass=""
              visible={loaderStatus}
              ariaLabel="blocks-wrapper"
            />
          </div>

          {!loaderStatus && (
            <div
              style={{ display: loaderStatus ? "none" : "flex" }}
              className="row"
            >
              {/* <Form.Group className='mb-2' controlId='formBasicOldPasssword'>
                            <Form.Label className='mb-1 dash-modal-form-label required'>Current Password</Form.Label>
                            <Form.Control type = "password" className='modal-input-placeholder' placeholder="Enter Current Password" 
                                // onChange={(event)=>this.handleChangePassword(event, 'oldPass')}
                                />
                        </Form.Group> */}
              <Form.Group className="mb-1 col-12" controlId="id-camera">
                <Form.Label className="mb-1 dash-modal-form-label required">
                  Camera
                </Form.Label>
                <Select
                  options={optionsCamera}
                  value={valueCameraSelect}
                  tabSelectsValue={false}
                  isClearable={true}
                  isSearchable={true}
                  onChange={(e, { action }) => {
                    onChangeSelectFilterModal(e, action, "camera");
                  }}
                />
              </Form.Group>

              <Form.Group className="mb-1 col-12" controlId="id-feature">
                <Form.Label className="mb-1 dash-modal-form-label required">
                  Feature
                </Form.Label>
                <Select
                  options={optionsFeature}
                  // className="select-class-modal-company"
                  // defaultValue={this.options_filter.filter(({value})=> value == 'time')} // set default value
                  // isLoading = {this.state.modal.updateJenis.input.company.isLoading}
                  value={valueFeatureSelect}
                  tabSelectsValue={false}
                  isClearable={true}
                  isSearchable={true}
                  onChange={(e, { action }) => {
                    onChangeSelectFilterModal(e, action, "feature");
                  }}
                />
                {/* <Form.Control type = "text" className='modal-input-placeholder'
                                placeholder="Enter Feature Name"
                                maxLength={100}
                                ref={refEmailInput}
                                value={objValueInput?.['Feature Name']}
                                disabled={loaderStatus}
                                onChange={(event)=>handleChangeInput(event, 'Feature Name')}
                            /> */}
              </Form.Group>

              <Form.Group className="mb-1 col-12" controlId="id-rawdata">
                <Form.Label className="mb-1 dash-modal-form-label required">
                  Raw Data
                </Form.Label>
                <Form.Control
                  type="text"
                  className="modal-input-placeholder"
                  placeholder="Enter Raw Data"
                  maxLength={100}
                  ref={refFullNameInput}
                  value={objValueInput?.["Raw Data"]}
                  disabled={loaderStatus}
                  onChange={(event) => handleChangeInput(event, "Raw Data")}
                />
              </Form.Group>
            </div>
          )}
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => handleClick_ChangePWD(false, "create")}
            disabled={loaderStatus}
          >
            Close
          </Button>
          <Button
            variant="primary"
            onClick={() => handleSubmit()}
            disabled={loaderStatus}
          >
            Save
          </Button>
        </Modal.Footer>

        <ToastContainer draggable pauseOnHover />
      </Modal>
    </>
  );
};

export default ModalCreateResults;
